export const formatEveryoneGroup = (groups: Array<any>, translate: (arg: any) => string) => {
  const formatGroups = Object.values(groups || []).map(group => {
    if (group.isAllGroup) {
      return {
        ...group,
        name: translate({
          id: 'EVERYONE_UPPERCASE',
        }),
      };
    }
    return group;
  });
  return formatGroups;
};

export default formatEveryoneGroup;
